import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    root: {
      height: '20px',
      width: '50%',
      alignItems: 'center',
      justifyContent: 'start',
      display: 'flex',
      cursor: 'pointer',
    },
    text: {
      fontSize: '12px',
      textTransform: 'capitalize',
      '&:hover': {
        backgroundColor: '#FFF',
      },
    },
    img: {
      [theme.breakpoints.down(480)]: {
        width: '32px',
        height: '32px',
      },
    }
  })
);

export default useStyles;
